module.exports = __webpack_public_path__ + "static/media/profile-img.b77bd4b7.jpg";